import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators, FormArray, ValidatorFn } from '@angular/forms';
import { GroupService } from '../../services/group/group.service';
import { UserService } from "../../services/user/user.service";
import { DashboardService } from "../../services/dashboard/dashboard.service";
import { MatDialog } from "@angular/material";
import { DateFormatDialog } from "../export-mail/export-mail.component";
import { CommonService } from '../../services/common/common.service';
import * as moment from 'moment';
@Component({
    selector: 'export-mail-scheduler',
    templateUrl: './export-mail-scheduler.component.html',
    styleUrls: ['./export-mail-scheduler.component.scss']
})
export class ExportSchedulerMailComponent implements OnInit {
    openSchedulerMail: boolean = false;
    scdTopOffset = 0;
    exportSchedulerMailForm: FormGroup;
    dashboardName;
    dailyA = [
        { id: "Sun", value: "Sun" },
        { id: "Mon", value: "Mon" },
        { id: "Tue", value: "Tue" },
        { id: "Wed", value: "Wed" },
        { id: "Thu", value: "Thu" },
        { id: "Fri", value: "Fri" },
        { id: "Sat", value: "Sat" }
    ];
    enumexportDType = [
        { id: "pdf", value: "PDF" },
        { id: "excel", value: "Excel" },
        { id: "csv", value: "CSV" },
    ];
    exportDType = [];
    dashboardId;
    groupIds;
    userExportPer;
    //minDate = moment().add(1,'days');
    minDate = moment().format();//.add(1,'days');

    constructor(
        public dialog: MatDialog,
        private groupService: GroupService,
        public fb: FormBuilder,
        private commonService: CommonService,
        private userService: UserService,
        private dashboardService: DashboardService
    ) {

        this.groupService.getAction().subscribe(res => {
            if (['openScheduledMail'].includes(res.action)) {
                this.openSchedulerMail = true;
                this.dashboardName = res.data.dashboardName;
                this.dashboardId = res.data.dashboardId;
                this.groupIds = res.data.groupIds;
                this.updateForm();
                //this will be used for group sections where we find offset of grp id and set the filter beside them
                $('.group-filter').hide();
                let topOffset = $('#' + this.groupIds).offset().top;
                topOffset = topOffset - 130;
                this.scdTopOffset = parseInt(topOffset.toString());
                $('.group-filter').show();
            }
        });

        let userP = this.userService.getLoggedInUser();
        this.userExportPer = userP.settings;
        this.userPermiExport();
    }

    ngOnInit() {
        this.createForm();
    }

    userPermiExport() {
        if (this.userExportPer.excel == "0")
            this.exportDType.push(this.enumexportDType.find((o) => o.id == "excel"));

        if (this.userExportPer.pdf == "0")
            this.exportDType.push(this.enumexportDType.find((o) => o.id == "pdf"));

        if (this.userExportPer.csv == "0")
            this.exportDType.push(this.enumexportDType.find((o) => o.id == "csv"));

    }
    createForm() {

        const dailyControls = this.dailyA.map(c => new FormControl(false));
        const exportControls = this.exportDType.map((c) => { new FormControl(false) });

        this.exportSchedulerMailForm = this.fb.group({
            to: ['', Validators.required],
            cc: [''],
            bcc: [''],
            subject: [this.dashboardName],
            reportName: [this.dashboardName],
            message: ["This is the " + this.dashboardName],
            dateFormat: ['YYYY-MM-D'],
            exportType: this.fb.array(exportControls, minSelectedCheckboxes(1)),
            mailBody: [],
            dayOffSet: ['', Validators.pattern('^[0-9]+$')],
            firstDay: [this.minDate],
            deliveryH: [],
            deliveryM: [],
            period: ['Weekly'],
            dailyList: this.fb.array(dailyControls),
            incFltInfo: true
        });
        this.exportSchedulerMailForm.get('deliveryH').setValue("00");
        this.exportSchedulerMailForm.get('deliveryM').setValue(":00");
    }

    updateForm() {
        // const dailyControls = this.dailyA.map(c => new FormControl(false));
        this.exportSchedulerMailForm.patchValue({
            to: '',
            cc: '',
            bcc: '',
            subject: this.dashboardName,
            dayOffSet: '',
            reportName: this.dashboardName,
            message: "This is the " + this.dashboardName,
            mailBody: 'Day Offset is a negative value. It is used to generate reports being sent regularly to setup a date (date range). You setup a day to receive reports and report get generated for the date [day offset] days ago.',
            deliveryH: '00',
            deliveryM: ':00',
            period: 'Weekly',
            incFltInfo: true
        });
        this.exportSchedulerMailForm.get('to').reset();
    }


    getExportMailType() {
        return <FormArray>this.exportSchedulerMailForm.controls['exportType'];
    }

    onSubmit() {
        // console.log(this.exportSchedulerMailForm.value);
        let period = this.exportSchedulerMailForm.get('period').value;
        let requestForm = {
            "dashboardId": this.dashboardId,
            "groupIds": this.groupIds,
            "exportType": this.dailyHeadersVal(this.exportSchedulerMailForm.value.exportType, this.exportDType, false),//this.exportSchedulerMailForm.get('exportType').value,
            "reportName": this.exportSchedulerMailForm.get('reportName').value,
            "emailTo": this.exportSchedulerMailForm.get('to').value,
            "emailCC": this.exportSchedulerMailForm.get('cc').value,
            "emailBCC": this.exportSchedulerMailForm.get('bcc').value,
            "emailSubject": this.exportSchedulerMailForm.get('subject').value,
            "emailBody": this.exportSchedulerMailForm.get('message').value,//this.exportSchedulerMailForm.get('mailBody').value,
            "firstDay": moment(this.exportSchedulerMailForm.get('firstDay').value).format("YYYY-MM-DD"),
            "emailTime": this.exportSchedulerMailForm.get('deliveryH').value + this.exportSchedulerMailForm.get('deliveryM').value,
            "dayOffset": this.exportSchedulerMailForm.get('dayOffSet').value,
            "period": period,
            "dateFormat": this.exportSchedulerMailForm.get('dateFormat').value,
            "days": period == "Daily" ? this.dailyHeadersVal(this.exportSchedulerMailForm.value.dailyList, this.dailyA, true) : "",
            "includeFilterInfo": (this.exportSchedulerMailForm.get('incFltInfo').value == true ? 1 : 0),
        };
        // console.log(requestForm);
        if (this.exportSchedulerMailForm.valid) {
            this.dashboardService.requestMail("scheduler/AddSchedule", requestForm).subscribe((res) => {
                this.commonService.openSnackBar("Mail scheduled", "");
                this.openSchedulerMail = false;
            }, (err) => {
                console.log(err);
                this.commonService.openSnackBar("Failed while mailing", "");
                this.openSchedulerMail = false;
            });
        }
    }

    getFormatDate() {
        this.dialog.open(DateFormatDialog, {
            data: {},
            height: "auto",
            width: "600px",
            panelClass: "full-modal"
        });
    }

    closeFilter() {
        this.openSchedulerMail = false;
    }

    dailyHeadersVal(formCValue, arrayLis, isDay) {

        let selectedHeaders = formCValue//this.exportSchedulerMailForm.value.dailyList
            .map((v, i) => v ? arrayLis[i].id : null)//this.dailyA[i].id : null)
            .filter(v => v !== null);

        if (isDay)
            //if it's daily and user has not selected any specific day pass all days
            selectedHeaders = selectedHeaders.length == 0 ? arrayLis.map((obj) => { return obj.id }) : selectedHeaders;
        return selectedHeaders;

    }
}
function minSelectedCheckboxes(min = 1) {
    const validator: ValidatorFn = (formArray: FormArray) => {
        const totalSelected = formArray.controls
            // get a list of checkbox values (boolean)
            .map(control => control.value)
            // total up the number of checked checkboxes
            .reduce((prev, next) => next ? prev + next : prev, 0);

        // if the total is not greater than the minimum, return the error message
        return totalSelected >= min ? null : { required: true };
    };

    return validator;
}


// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/export/export-mail-scheduler/export-mail-scheduler.component.ts